module.exports = __webpack_public_path__ + "img/编组 50.5ecc1593.png";